export const IRISH_FUNDS_CONTEXT = {
  name: "Irish Funds",
  established: 1991,
  description: "The industry association for the international investment funds community in Ireland",
  mission: "To promote Ireland as the leading location for international fund services and support our members through advocacy, education, and networking",
  
  services: {
    memberServices: [
      "Industry advocacy and representation",
      "Regulatory guidance and support", 
      "Working groups and committees",
      "Educational events and training",
      "Networking opportunities",
      "Policy development and consultation"
    ],
    
    keyAreas: [
      "Fund domiciliation and administration",
      "Asset management services",
      "UCITS and AIFM regulations",
      "ETF market development",
      "ESG and sustainable finance",
      "Cross-border distribution",
      "Regulatory compliance",
      "Tax and legal frameworks"
    ]
  },
  
  regulations: {
    eu: ["UCITS", "AIFMD", "SFDR", "EU Taxonomy", "MiFID II", "CSDR"],
    irish: ["Central Bank regulations", "Irish Fund Law", "Tax legislation"],
    global: ["FATCA", "CRS", "OECD guidelines"]
  },
  
  memberTypes: [
    "Fund management companies",
    "Investment advisors", 
    "Fund administrators",
    "Custodians and depositaries",
    "Transfer agents",
    "Legal and professional services",
    "Technology providers"
  ]
};

// Nano AI Topic Filter Configuration (Backend-based)
export const NANO_TOPIC_FILTER = {
  endpoint: "/daire/topic-filter", // Your backend endpoint
  method: "POST",
  
  fallbackResponse: {
    allowed: false, // SAFER: Block queries when filter fails
    confidence: "fallback",
    reason: "Filter unavailable - redirecting for safety"
  }
};  

// Redirect Messages - REMOVED (Topic filter disabled)

// AI System Configuration
export const DAIRE_AI_CONFIG = {
  // Main system prompt for Daire
  systemPrompt: `You are Daire, a sophisticated AI assistant for Irish Funds members. You provide expert guidance on:

CORE EXPERTISE:
- Irish Funds organization and member services
- Investment fund regulations (UCITS, AIFMD, SFDR, MiFID II)
- ETF and fund market analysis
- ESG and sustainable finance
- Regulatory compliance and guidance
- Working groups and industry committees
- Professional development and networking

PERSONALITY:
- Professional yet approachable
- Knowledgeable about complex financial regulations
- Supportive of member needs and queries
- Proactive in providing relevant context
- Clear communicator of technical concepts

RESPONSE STYLE:
- Use member's first name when appropriate
- Provide specific, actionable information
- Include relevant regulatory context
- Offer to elaborate on complex topics
- Maintain professional Irish Funds tone

Your role is to be the intelligent interface between Irish Funds members and the organization's knowledge base, helping them navigate the complex world of international fund services.`,

  // Topic classification prompts
  intentClassification: {
    searchIntent: "User is seeking specific information or documents",
    casualIntent: "User is making general conversation or asking basic questions", 
    educationalIntent: "User wants to learn about concepts or industry topics",
    regulatoryIntent: "User needs guidance on compliance or regulatory matters"
  },

  // Response formatting guidelines
  formatting: {
    useMarkdown: true,
    includeEmojis: "sparingly for professional context",
    maxResponseLength: 800,
    includeSourceAttribution: true
  }
};

// Topic Filter Implementation - DISABLED (Allow all queries)
export const executeTopicFilter = async (query) => {
  // Topic filter disabled - allow all queries through
  return {
    allowed: true,
    confidence: "disabled",
    method: "filter_disabled"
  };
};

// Helper function - REMOVED (Topic filter disabled)

// Validate environment setup
export const validateDaireConfig = () => {
  const checks = {
    apiUrl: !!process.env.REACT_APP_API_URL,
    backendAvailable: true
  };
  
  return checks;
};

// Export everything needed for DaireChat integration
export default {
  IRISH_FUNDS_CONTEXT,
  NANO_TOPIC_FILTER,
  DAIRE_AI_CONFIG,
  executeTopicFilter,
  validateDaireConfig
}; 